import { makeAutoObservable } from "mobx";
import { RouterStore } from "@ibm/mobx-react-router";
import CalendarStore from "./CalendarStore";
import CareDaysStore from "./CareDaysStore";
import EQ5D5LStore from "./EQ5D5LStore";
import ImmunoglobulinStore from "./ImmunoglobulinStore";
import NoteStore from "./NoteStore";
import SickDaysStore from "./SickDaysStore";
import { UserStore } from "./UserStore";
import { TransportService } from "../services/TransportService";
import ClientStore from "./ClientStore";
import DrugStore from "./DrugStore";
import FieldStore from "./FieldStore";
import FormStore from "./FormStore";
import IndicationStore from "./IndicationStore";
import MeasurementStore from "./MeasurementStore";
import TreatmentStore from "./TreatmentStore";
import ConfigStore from "./ConfigStore";
import { KeycloakStore } from "./KeycloakStore";

export class RootStore {
  transportService: TransportService;
  configStore: ConfigStore;
  keycloakStore: KeycloakStore
  routerStore: RouterStore;
  calendarStore: CalendarStore;
  careDaysStore: CareDaysStore;
  eQ5D5LStore: EQ5D5LStore;
  immunoglobulinStore: ImmunoglobulinStore;
  noteStore: NoteStore;
  sickDaysStore: SickDaysStore;
  userStore: UserStore;
  clientStore: ClientStore;
  drugStore: DrugStore;
  fieldStore: FieldStore;
  formStore: FormStore;
  indicationStore: IndicationStore;
  measurementStore: MeasurementStore;
  treatmentStore: TreatmentStore;

  constructor() {
    this.transportService = new TransportService();
    this.configStore = new ConfigStore(this.transportService);
    this.keycloakStore = new KeycloakStore(this);
    this.routerStore = new RouterStore();
    this.calendarStore = new CalendarStore(this);
    this.careDaysStore = new CareDaysStore(this);
    this.eQ5D5LStore = new EQ5D5LStore(this);
    this.immunoglobulinStore = new ImmunoglobulinStore(this);
    this.noteStore = new NoteStore(this);
    this.sickDaysStore = new SickDaysStore(this);
    this.userStore = new UserStore(this.transportService, this);
    this.clientStore = new ClientStore(this.transportService, this);
    this.drugStore = new DrugStore(this.transportService, this);
    this.fieldStore = new FieldStore(this.transportService, this);
    this.formStore = new FormStore(this.transportService, this);
    this.indicationStore = new IndicationStore(this.transportService, this);
    this.measurementStore = new MeasurementStore(this.transportService, this);
    this.treatmentStore = new TreatmentStore(this.transportService, this);

    makeAutoObservable(this);
  }
}
